import type { ReactNode } from 'react'

/** DESIGN.md badge-pill: surface-strong fill, caption-strong type, pill radius. */
export function Badge({
  children,
  className = '',
  tone = 'default',
}: {
  children: ReactNode
  className?: string
  tone?: 'default' | 'dark'
}) {
  const toneClass =
    tone === 'dark' ? 'bg-white/10 text-on-dark' : 'bg-surface-strong text-ink'
  return (
    <span
      className={`t-caption-strong inline-flex items-center rounded-[100px] px-3 py-1 ${toneClass} ${className}`}
    >
      {children}
    </span>
  )
}
